import { finish, error } from '../../../modules/user/actions/change-odds';

import api from '../../../api';

export function request(dispatch, action) {
    api.post('/user/change-odds', {
        oddsFormat: action.oddsFormat
    }).then(
        ({ data }) => dispatch(finish(data)),
        ({ errors }) => dispatch(error(errors))
    );
}
